"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getMaxDate = exports.getMinDate = exports.getUnixTimeStamp = exports.durationAsMinutes = exports.isAwsDateString = exports.fromUnixTimestamp = exports.dateRelativeTimeRounding = exports.fromNow = exports.getDateInstance = exports.setGlobalDateLocale = exports.setDateLocalized = exports.getDateLocalized = exports.setYear = exports.getYear = exports.setMonth = exports.getMonth = exports.setDay = exports.getDay = exports.setDate = exports.getDate = exports.setMiliseconds = exports.getMiliseconds = exports.setSeconds = exports.getSeconds = exports.setMinutes = exports.getMinutes = exports.setHours = exports.getHours = exports.endOfDate = exports.startOfDate = exports.isValidDate = exports.isBetweenDates = exports.isSameOrAfterDate = exports.isSameOrBeforeDate = exports.isSameDate = exports.isAfterDate = exports.isBeforeDate = exports.getCurrentTimezoneAbbr = exports.getCurrentTimezone = exports.durationAsHours = exports.getCurrentLocaleTimestamp = exports.toDate = exports.diffDate = exports.subtractDate = exports.addDate = exports.cloneDateInstance = exports.dateToUTCInstance = exports.dateToUTCString = exports.dateToISOString = exports.formatDate = void 0;
exports.generateDate = exports.setTimeUnits = exports.setTimeToDate = void 0;
const moment_1 = __importDefault(require("moment"));
const moment_timezone_1 = __importDefault(require("moment-timezone"));
const formatDate = (targetFormat = null, date, currentFormat = undefined, timezone = null) => {
    if (timezone) {
        return (0, moment_timezone_1.default)(date, currentFormat).tz(timezone).format(targetFormat);
    }
    return targetFormat ? (0, moment_1.default)(date, currentFormat).format(targetFormat) : (0, moment_1.default)(date, currentFormat).format();
};
exports.formatDate = formatDate;
const dateToISOString = (date, preventUTCConversion = false) => (0, moment_1.default)(date).toISOString(preventUTCConversion);
exports.dateToISOString = dateToISOString;
const dateToUTCString = (date, locale) => locale ? (0, moment_1.default)(date).locale(locale).utc().format() : (0, moment_1.default)(date).utc().format();
exports.dateToUTCString = dateToUTCString;
const dateToUTCInstance = (date, timezone, locale) => locale
    ? timezone
        ? moment_timezone_1.default.tz(date, timezone).locale(locale).utc()
        : (0, moment_1.default)(date).locale(locale).utc()
    : timezone
        ? moment_timezone_1.default.tz(date, timezone).utc()
        : (0, moment_1.default)(date).utc();
exports.dateToUTCInstance = dateToUTCInstance;
// @todo: deprecate this method once we move to a new library
const cloneDateInstance = (value) => value.clone();
exports.cloneDateInstance = cloneDateInstance;
const addDate = (value, unit, currentTime) => (0, moment_1.default)(currentTime).add(value, unit);
exports.addDate = addDate;
const subtractDate = (value, unit, currentTime) => (0, moment_1.default)(currentTime).subtract(value, unit);
exports.subtractDate = subtractDate;
const diffDate = (currentDate, targetDate, unit) => (0, moment_1.default)(currentDate).diff(targetDate, unit);
exports.diffDate = diffDate;
const toDate = (value, format) => (0, moment_1.default)(value, format).toDate();
exports.toDate = toDate;
const getCurrentLocaleTimestamp = (locale = 'en') => (0, moment_1.default)().locale(locale).format();
exports.getCurrentLocaleTimestamp = getCurrentLocaleTimestamp;
const durationAsHours = (value) => moment_1.default.duration(value).asHours();
exports.durationAsHours = durationAsHours;
const getCurrentTimezone = () => Intl.DateTimeFormat().resolvedOptions().timeZone;
exports.getCurrentTimezone = getCurrentTimezone;
const getCurrentTimezoneAbbr = () => moment_timezone_1.default.tz((0, exports.getCurrentTimezone)()).zoneAbbr();
exports.getCurrentTimezoneAbbr = getCurrentTimezoneAbbr;
const isBeforeDate = (beforeDate, afterDate, granularity) => (0, moment_1.default)(beforeDate).isBefore(afterDate, granularity);
exports.isBeforeDate = isBeforeDate;
const isAfterDate = (beforeDate, afterDate, unit) => (0, moment_1.default)(beforeDate).isAfter(afterDate, unit);
exports.isAfterDate = isAfterDate;
const isSameDate = (value1, value2, unit) => (0, moment_1.default)(value1).isSame(value2, unit);
exports.isSameDate = isSameDate;
const isSameOrBeforeDate = (value1, value2, unit) => (0, moment_1.default)(value1).isSameOrBefore(value2, unit);
exports.isSameOrBeforeDate = isSameOrBeforeDate;
const isSameOrAfterDate = (value1, value2, unit) => (0, moment_1.default)(value1).isSameOrAfter(value2, unit);
exports.isSameOrAfterDate = isSameOrAfterDate;
const isBetweenDates = (start, end, currentTime, unit, inclusivity) => (0, moment_1.default)(currentTime).isBetween(start, end, unit, inclusivity);
exports.isBetweenDates = isBetweenDates;
const isValidDate = (date, currentFormat, strict) => (0, moment_1.default)(date, currentFormat, strict).isValid();
exports.isValidDate = isValidDate;
const startOfDate = (date, unit) => (0, moment_1.default)(date).startOf(unit);
exports.startOfDate = startOfDate;
const endOfDate = (date, unit) => (0, moment_1.default)(date).endOf(unit);
exports.endOfDate = endOfDate;
const getHours = (date) => (0, moment_1.default)(date).hours();
exports.getHours = getHours;
const setHours = (value, date) => (0, moment_1.default)(date).hours(value);
exports.setHours = setHours;
const getMinutes = (date) => (0, moment_1.default)(date).minutes();
exports.getMinutes = getMinutes;
const setMinutes = (value, date) => (0, moment_1.default)(date).minutes(value);
exports.setMinutes = setMinutes;
const getSeconds = (date) => (0, moment_1.default)(date).seconds();
exports.getSeconds = getSeconds;
const setSeconds = (value, date) => (0, moment_1.default)(date).seconds(value);
exports.setSeconds = setSeconds;
const getMiliseconds = (date) => (0, moment_1.default)(date).milliseconds();
exports.getMiliseconds = getMiliseconds;
const setMiliseconds = (value, date) => (0, moment_1.default)(date).milliseconds(value);
exports.setMiliseconds = setMiliseconds;
const getDate = (date) => (0, moment_1.default)(date).date();
exports.getDate = getDate;
const setDate = (value, date) => (0, moment_1.default)(date).date(value);
exports.setDate = setDate;
const getDay = (date) => (0, moment_1.default)(date).day();
exports.getDay = getDay;
const setDay = (value, date) => (0, moment_1.default)(date).day(value);
exports.setDay = setDay;
const getMonth = (date) => (0, moment_1.default)(date).month();
exports.getMonth = getMonth;
const setMonth = (value, date) => (0, moment_1.default)(date).month(value);
exports.setMonth = setMonth;
const getYear = (date) => (0, moment_1.default)(date).year();
exports.getYear = getYear;
const setYear = (value, date) => (0, moment_1.default)(date).year(value);
exports.setYear = setYear;
const getDateLocalized = (date) => (0, moment_1.default)(date).locale();
exports.getDateLocalized = getDateLocalized;
const setDateLocalized = (locale = 'en', date) => (0, moment_1.default)(date).locale(locale);
exports.setDateLocalized = setDateLocalized;
const setGlobalDateLocale = (locale = 'en') => moment_1.default.locale(locale);
exports.setGlobalDateLocale = setGlobalDateLocale;
const getDateInstance = (value, targetFormat, language, strict) => (0, moment_1.default)(value, targetFormat, language, strict);
exports.getDateInstance = getDateInstance;
const fromNow = (date, withoutSuffix, language) => (0, exports.getDateInstance)(date, null, language).fromNow(withoutSuffix);
exports.fromNow = fromNow;
const dateRelativeTimeRounding = (roundingFunction) => moment_1.default.relativeTimeRounding(roundingFunction);
exports.dateRelativeTimeRounding = dateRelativeTimeRounding;
const fromUnixTimestamp = (value) => moment_1.default.unix(value);
exports.fromUnixTimestamp = fromUnixTimestamp;
const isAwsDateString = (str) => {
    // Credit: https://stackoverflow.com/questions/3143070/javascript-regex-iso-datetime -- Brock Adams
    const regex = /(\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d\.\d+)|(\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d)|(\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d)/;
    return regex.test(str);
};
exports.isAwsDateString = isAwsDateString;
const durationAsMinutes = (value) => moment_1.default.duration(value).asMinutes();
exports.durationAsMinutes = durationAsMinutes;
const getUnixTimeStamp = (date) => (0, moment_1.default)(date).valueOf();
exports.getUnixTimeStamp = getUnixTimeStamp;
const getMinDate = (dates, format) => moment_1.default.min(dates.map((e) => (0, moment_1.default)(e, format)));
exports.getMinDate = getMinDate;
const getMaxDate = (dates, format) => moment_1.default.max(dates.map((e) => (0, moment_1.default)(e, format)));
exports.getMaxDate = getMaxDate;
const setTimeToDate = (date, timeToAdd = null) => {
    const minTime = timeToAdd != null ? `${(0, exports.formatDate)('YYYY-MM-DD')} ${timeToAdd}` : date;
    let newDate = (0, exports.setHours)((0, exports.getHours)(minTime), date);
    newDate = (0, exports.setMinutes)((0, exports.getMinutes)(minTime), newDate);
    newDate = (0, exports.setSeconds)(0, newDate);
    newDate = (0, exports.setMiliseconds)(0, newDate);
    return (0, exports.toDate)(newDate);
};
exports.setTimeToDate = setTimeToDate;
const setTimeUnits = (date, values) => {
    const { hours = 0, minutes = 0, seconds = 0, milliseconds = 0 } = values;
    let newDate = (0, exports.setHours)(hours, date);
    newDate = (0, exports.setMinutes)(minutes, newDate);
    newDate = (0, exports.setSeconds)(seconds, newDate);
    newDate = (0, exports.setMiliseconds)(milliseconds, newDate);
    return (0, exports.toDate)(newDate);
};
exports.setTimeUnits = setTimeUnits;
const generateDate = (date, time) => date && time ? (0, exports.toDate)(`${date}T${time}`) : date ? (0, exports.toDate)(`${date}T00:00:00.000Z`) : null;
exports.generateDate = generateDate;
